import gql from 'graphql-tag';
import ProductCategory from '../../../entity/productCategory';

const getProductCategory = gql`
  query productCategoryByStore($id: IDString!) {
    productCategoryByStore(id: $id) {
      ${ProductCategory.fragmentsFields()}
    }
  }
`;

export default getProductCategory;
